export default __webpack_public_path__ + "static/media/nestjs.78696416.png";